<script setup lang="ts">
const props = defineProps<{
  active?: boolean;
  disabled?: boolean;
  ariaLabel?: string;
  onClick?: () => void;
}>();

const internalIsFocused = ref(false);
const paginationButton = templateRef('pagination-button');

const paginationContext = usePaginationContext();
const theme = usePaginationTheme();

const displayLoadingState = computed(() => {
  const isLatestClickedButton =
    paginationContext.latestClickedButton.value != null &&
    paginationContext.latestClickedButton.value === paginationButton.value;
  return Boolean(paginationContext.paginationCausedLoading.value && isLatestClickedButton);
});

const state = computed(() => {
  if (displayLoadingState.value) {
    return 'loading';
  }

  if (props.active) {
    return 'active';
  }

  if (props.disabled) {
    return 'disabled';
  }

  return 'default';
});

function handleClick() {
  paginationContext.setLatestClickedButton(paginationButton.value);

  if (props.onClick) {
    props.onClick();
  }
}
</script>

<template>
  <button
    ref="pagination-button"
    :class="theme.button({ state, focused: internalIsFocused })"
    :disabled="props.disabled"
    :aria-label="props.ariaLabel"
    @focusin="internalIsFocused = true"
    @focusout="internalIsFocused = false"
    @click="handleClick"
  >
    <slot />
  </button>
</template>
